import SvgIcon from "@mui/material/SvgIcon";

export const ProtractorIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 17h20M4 17a8 8 0 0 1 16 0"
    />
    <path fill="none" stroke="currentColor" strokeWidth="1.2" d="M12 17V9" />
    <path fill="none" stroke="currentColor" strokeWidth="1.2" d="M12 17 6.7 12.7M12 17l5.3-4.3" />
    <circle cx="12" cy="17" r="1.1" fill="currentColor" />
  </SvgIcon>
);

export const SetSquareIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
      d="M4 20 20 20 4 4Z"
    />
    <path fill="none" stroke="currentColor" strokeWidth="1.2" d="M4 16h3v3" />
    <path fill="none" stroke="currentColor" strokeWidth="0.9" d="M8 18l2-2M11 18l3-3M14 18l3-3" />
  </SvgIcon>
);
